import { render } from "./orderLog.vue?vue&type=template&id=f20726be&scoped=true"
import script from "./orderLog.vue?vue&type=script&lang=js"
export * from "./orderLog.vue?vue&type=script&lang=js"

import "./orderLog.vue?vue&type=style&index=0&id=f20726be&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20726be"]])

export default __exports__